import React, { useEffect } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";

import { Main2 } from "@/components/layout/Main";
import { redirectOnSignIn } from "@/utils/redirectOnSignIn";

import { OnboardingWorkflow } from "./components/OnboardingWorkflow";

// Authenticated entry point for the system:workflow role. Renders
// OnboardingWorkflow under /workflow and redirects the portal root there.
export function OnboardingRouter({ url }: { url: string }) {
  const history = useHistory();

  useEffect(() => {
    redirectOnSignIn(history);
  }, [history]);

  return (
    <Main2>
      <Switch>
        <Route component={OnboardingWorkflow} path={url + "/workflow"} />
        <Redirect from={url} to={url + "/workflow"} />
      </Switch>
    </Main2>
  );
}
